import React, { useMemo, useState } from "react";
import GridTable from "../../constant/GridTable";
import moment from "moment";
import { exchangeType, parseDate } from "../../constant/enum";

function TradeHistory({ tradeHistory }) {
  const [colDefs] = useState([
    {
      headerName: "Sr.No.",
      field: "id",
      valueGetter: "node.rowIndex + 1",
      sortable: true,
      filter: "agNumberColumnFilter",
    },
    {
      headerName: "Exchange",
      field: "exchange_type",
      sortable: true,
      cellRenderer: (params) => {
        return (
          <>
            {
              exchangeType.filter(
                (list) => list.value == params.data.exchange_type
              )[0]?.key
            }
          </>
        );
      },
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Symbol",
      field: "symbol",
      sortable: true,
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Order ID",
      field: "order_id",
      sortable: true,
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Quantity",
      field: "quantity",
      sortable: true,
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Trade Type",
      field: "trade_type",
      sortable: true,
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Positiion Side",
      field: "position_side",
      sortable: true,
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Open/Close Price",
      field: "open_price",
      sortable: true,
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Order Side",
      field: "order_side",
      sortable: true,
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Order Type",
      field: "order_type",
      sortable: true,
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Status",
      field: "trade_status",
      sortable: true,
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Date",
      field: "createdAt",
      cellRenderer: (params) => {
        return <>{moment(params.value).format("lll")}</>;
      },
      sortable: true,
      filter: "agDateColumnFilter",
      filterParams: {
        comparator: (filterLocalDateAtMidnight, cellValue) => {
          const cellDate = parseDate(cellValue);
          if (!cellDate) {
            return -1;
          }
          if (cellDate.getTime() === filterLocalDateAtMidnight.getTime()) {
            return 0;
          }
          return cellDate < filterLocalDateAtMidnight ? -1 : 1;
        },
      },
    },
  ]);
  const rowClassRules = useMemo(() => {
    return {
      "sick-days-warning": "data.order_side =='SELL'",
      "sick-days-breach": "data.order_side =='BUY'",
    };
  }, []);
  return (
    <div className=" ">
      <h4 className="trade_history">Trade History</h4>
      <div>
        <GridTable
          data={tradeHistory}
          colDefs={colDefs}
          height="100vh"
          rowClassRules={rowClassRules}
        />
      </div>
    </div>
  );
}

export default TradeHistory;
